import "./../css/single.scss";
import $ from 'jquery';

$(document).ready(function () {
    /* Prefill floating nav with H2 headlines ===========================*/
    var articleID = $('article').attr('id');
    prefillFloatingNavigation(articleID);
});

function prefillFloatingNavigation(id) {
    var i = 1;
    var element = $('article#' + id + ' .post-content h2');
    if (element.length) {
        element.each(function () {
            var content = $(this).text();
            $(this).attr('id', id + '-headline-h2-' + i);
            $("article#" + id + " .blog-floating-nav .sticky").append("<div  class='content-headline' data-scroll='headline-h2-" + i + "'><a href='#" + id + "-headline-h2-" + i + "'>" + content + "</a></div>");
            i++;
        });
    } else {
        $('.blog-floating-nav').hide();
    }
}

const progressBar = document.querySelector('.progress-bar');
const section = document.querySelector('body');

if (typeof (progressBar) != 'undefined' && progressBar != null) {
    const scrollProgressBar = () => {
        let scrollDistance = -(section.getBoundingClientRect().top);
        let progressPercentage =
            (scrollDistance /
                (section.getBoundingClientRect().height -
                    document.documentElement.clientHeight)) * 100;

        let val = Math.floor(progressPercentage);
        progressBar.style.width = val + '%';

        if (val < 0) {
            progressBar.style.width = '0%';
        }
    };

    window.addEventListener('scroll', scrollProgressBar);
}